(function(){
  if(window.__inbikeCartRewardsStarted)return;
  window.__inbikeCartRewardsStarted=true;
  var scheduled=0, inFlight=false;
  var shippingCents=JSON.parse(document.querySelector('[data-inbike-rewards]').getAttribute('data-ibk-config-0'));
  var socksCents=JSON.parse(document.querySelector('[data-inbike-rewards]').getAttribute('data-ibk-config-1'));
  var balaclavaCents=JSON.parse(document.querySelector('[data-inbike-rewards]').getAttribute('data-ibk-config-2'));
  var bfEnabled=false; /* Daily-only draft; BF rewards disabled. */
  function usd(cents){return '$'+(Math.max(0,cents)/100).toFixed(2)}
  function bfToday(){
    var parts=new Intl.DateTimeFormat('en-US',{timeZone:'America/New_York',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    var map={};parts.forEach(function(p){map[p.type]=p.value});
    var y=Number(map.year),m=Number(map.month),d=Number(map.day);
    return y===2026&&m===11&&d>=14&&d<=30;
  }
  function schedule(){clearTimeout(scheduled);scheduled=setTimeout(update,280)}
  function render(cart){
    var root=document.querySelector('[data-inbike-rewards]');if(!root)return;
    var bf=bfEnabled&&bfToday(),currency=cart.currency||'USD';
    var subtotal=cart.total_price||0;
    /* Explicitly exclude known non-physical Worry-Free Purchase item.
       Cart-level discounts can make this an estimate; verify at checkout. */
    (cart.items||[]).forEach(function(i){
      if(/worry.free purchase/i.test(i.product_title||i.title||'')) subtotal-=i.final_line_price||0;
    });
    subtotal=Math.max(0,subtotal);
    var h=root.querySelector('[data-ibf-heading]');
    var m=root.querySelector('[data-ibf-message]');
    var bar=root.querySelector('[data-ibf-fill]');
    var marks=root.querySelector('[data-ibf-marks]');
    var note=root.querySelector('[data-ibf-note]');
    if(!cart.items||!cart.items.length){root.hidden=true;return}
    root.hidden=false;
    root.classList.remove('ibf-cr-compact');
    if(currency!=='USD'){
      h.textContent='INBIKE Cart Rewards';
      m.textContent='Reward eligibility is based on the eligible USD order subtotal.';
      bar.style.width='0%';marks.textContent='';
      note.textContent='Please confirm your final qualifying amount at checkout.';
      return;
    }
    root.classList.toggle('ibf-cr-compact', !bf && subtotal>=shippingCents);
    if(bf){
      h.textContent='Black Friday Gifts';
      if(subtotal>=balaclavaCents)m.textContent='Your order qualifies for a FREE X-6 windproof balaclava!';
      else if(subtotal>=socksCents)m.textContent='Free cycling socks unlocked! Add '+usd(balaclavaCents-subtotal)+' more to upgrade your gift.';
      else m.textContent='Add '+usd(socksCents-subtotal)+' more to qualify for free cycling socks.';
      bar.style.width=Math.min(100,subtotal/balaclavaCents*100)+'%';
      marks.innerHTML='<span>'+usd(socksCents)+' · Free Socks</span><span>'+usd(balaclavaCents)+' · Free Balaclava</span>';
      note.textContent='One gift per qualifying order; higher tier replaces lower. Socks: one size, random color. Gifts are packed with your order; Gift eligibility is based on final discounted merchandise subtotal at checkout; Bundler adjustments may change your reward.';
    }else{
      h.textContent='Free Shipping';
      m.textContent=subtotal>=shippingCents?'You have unlocked FREE SHIPPING!':'Add '+usd(shippingCents-subtotal)+' more for free shipping.';
      bar.style.width=Math.min(100,subtotal/shippingCents*100)+'%';
      marks.textContent=usd(shippingCents)+' · Free Shipping';
      note.textContent='Shipping eligibility is confirmed at checkout.';
    }
  }
  async function update(){
    if(inFlight)return;
    if(!document.querySelector('[data-inbike-rewards]'))return;
    inFlight=true;
    try{
      var res=await fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!res.ok)throw new Error('cart read failed');
      render(await res.json());
    }catch(err){
      var root=document.querySelector('[data-inbike-rewards]');
      if(root){root.hidden=false;root.querySelector('[data-ibf-message]').textContent='Cart rewards will be confirmed at checkout.'}
    }finally{inFlight=false}
  }
  function initialize(){
    schedule();
    var obs=new MutationObserver(function(records){
      for(var i=0;i<records.length;i++){
        var target=records[i].target;
        if(target instanceof Element&&target.closest('[data-inbike-rewards], [data-ibk-bundle-tip]'))continue;
        if(target instanceof Element&&target.closest('cart-drawer-component')){schedule();break}
      }
    });
    var drawer=document.querySelector('cart-drawer-component');
    if(drawer)obs.observe(drawer,{subtree:true,childList:true});
    document.addEventListener('click',function(e){
      if(e.target.closest('[data-testid="cart-drawer-trigger"], .cart-items__quantity-controls, .cart-items__remove'))setTimeout(schedule,500);
    },true);
    document.addEventListener('change',function(e){
      if(e.target.closest('cart-drawer-component'))setTimeout(schedule,500);
    },true);
    document.addEventListener('shopify:section:load',schedule);
    document.addEventListener('cart:update',schedule);
    document.addEventListener('cart:updated',schedule);
    document.addEventListener('bundler:total_cart_values',schedule);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
})();
